/**
 * Shared "is this site contact stale?" helper for dispatch surfaces.
 *
 * A site's default contact is considered stale when it has NEVER been verified
 * or was last confirmed more than 12 months ago. Dispatch shows an amber chip
 * and the drop handler warns the dispatcher so they re-confirm the on-my-way /
 * confirmation phone number before the job goes out.
 */
export const CONTACT_STALE_MONTHS = 12;

export function isContactStale(lastVerifiedAt: string | null | undefined): boolean {
    if (!lastVerifiedAt) return true;
    const verified = new Date(lastVerifiedAt);
    if (Number.isNaN(verified.getTime())) return true;
    const cutoff = new Date();
    cutoff.setMonth(cutoff.getMonth() - CONTACT_STALE_MONTHS);
    return verified.getTime() < cutoff.getTime();
}

/** Human label for a contact's verification state. */
export function formatVerifiedLabel(lastVerifiedAt: string | null | undefined): string {
    if (!lastVerifiedAt) return "Never verified";
    const d = new Date(lastVerifiedAt);
    if (Number.isNaN(d.getTime())) return "Never verified";
    return `Last verified ${d.toLocaleDateString()}`;
}
